import reducerRegistry from '@comeon/reducer-registry';

export interface TournamentRankMessage {
	tournamentId: number;
	playerRank: number;
	playerPoint: number;
}

export interface State {
	rankMessage: TournamentRankMessage | undefined;
	gameCodes: string[];
}

export type Action =
	| {
			type: typeof SET_RANK_MESSAGE;
			payload: TournamentRankMessage;
	  }
	| {
			type: typeof ADD_GAME_CODE;
			payload: string;
	  };

// Constants

export const REDUCER_NAME = 'casinoTournaments';
const ACTION_NAME_PREFIX = '@komigen/mobile-frontend/casino-tournament';

export const SET_RANK_MESSAGE = `${ACTION_NAME_PREFIX}/SET_RANK_MESSAGE`;
export const ADD_GAME_CODE = `${ACTION_NAME_PREFIX}/ADD_GAME_CODE`;

// Actions

export const setRankMessage = (rankMessage: TournamentRankMessage): Action => ({
	type: SET_RANK_MESSAGE,
	payload: rankMessage
});

export const addGameCode = (gameCode: string): Action => ({
	type: ADD_GAME_CODE,
	payload: gameCode
});

// Reducer

const initialState: State = {
	rankMessage: undefined,
	gameCodes: []
};

const reducer = (state = initialState, { type, payload }: Action) => {
	switch (type) {
		case SET_RANK_MESSAGE:
			return {
				...state,
				rankMessage: payload
			} as State;
		case ADD_GAME_CODE:
			if (typeof payload === 'string' && !state.gameCodes.includes(payload)) {
				return {
					...state,
					gameCodes: [...state.gameCodes, payload]
				} as State;
			}
			return state;
		default:
			return state;
	}
};

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
